// 浏览器相关

export default {
  setHtmlSeo(data) {
    const finalData = Object.assign({}, {
      title: '上上签-旅游同业签证办理的智能平台,在线办理出国签证,不限领区办理,加急预约',
      keywords: '上上签,出境游,签证办理,日本签证,出国签证,美国签证,越南签证,申根签证,旅游签,商务签',
      description: '上上签-国内领先签证办理平台,专注为同业提供全球专业签证服务,涵盖个人签、旅游签、商务签、探亲访友签等多种类型,签证覆盖日本、韩国、美国、越南、澳大利亚、印尼、申根等国家。此外还可查询领馆假期、资料清单、办理流程、办理条件、办理费用及出行日期等服务',
    }, data);
    document.title = finalData.title;
    const keywordsMeta = document.querySelector('meta[name="keywords"]');
    const descriptionMeta = document.querySelector('meta[name="description"]');
    keywordsMeta.setAttribute('content', finalData.keywords);
    descriptionMeta.setAttribute('content', finalData.description);
  },
};



// WEBPACK FOOTER //
// ./src/services/browser-service.js